module.exports = __webpack_public_path__ + "img/building-2.bf395b0d.svg";